var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6025 8C14.7026 8 9.78129 12.1897 8.65136 17.7561H18.8677C18.2643 18.1718 17.69 18.648 17.1533 19.1847C12.9814 23.3567 12.4641 29.7992 15.6013 34.5343L28.1575 21.9781C27.8696 22.6081 27.5754 23.291 27.2816 24.0255C25.5464 28.3635 23.8254 34.5067 23.5258 42.2164C16.9014 42.6933 10.9431 45.5753 6.51977 49.9937C5.35695 51.1552 6.25568 53 7.89924 53H43.0612C44.7047 53 45.6034 51.1552 44.4406 49.9937C40.0383 45.5963 34.1155 42.7207 27.5288 42.2234C27.8245 35.0995 29.417 29.4573 30.9955 25.5111C31.8704 23.3238 32.7409 21.6579 33.3834 20.5515C33.4068 20.5112 33.4299 20.4717 33.4526 20.4329L47.5542 34.5344C50.6916 29.7994 50.1742 23.3567 46.0023 19.1847C45.4656 18.648 44.8913 18.1718 44.288 17.7561H54.5045C53.3746 12.1897 48.4533 8 42.5534 8C37.7265 8 33.5545 10.8043 31.578 14.8726C29.6014 10.8043 25.4295 8 20.6025 8Z",
    fill: "#030D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacation);
export default __webpack_public_path__ + "static/media/Vacation.0bf1140c6f48e33bd45319f6b351f77f.svg";
export { ForwardRef as ReactComponent };